export default __webpack_public_path__ + "static/media/buyBestBanner1.3120ce27.png";